import { render } from "./SendFeedbackDialog.vue?vue&type=template&id=4f2371d4&scoped=true"
import script from "./SendFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./SendFeedbackDialog.vue?vue&type=script&lang=js"

import "./SendFeedbackDialog.vue?vue&type=style&index=0&id=4f2371d4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2371d4"]])

export default __exports__